/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { Button, Stack } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import ResetButton from 'components/cmn/ResetButton';
import AccountsTable from 'components/project/enter-information/AccountsTable';
import { useProject } from 'hooks/useProject';
import { useAppDispatch } from 'store';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import { closeDialog } from 'store/dialog/dialogSlice';
import { changeStepper1Value } from 'store/project/projectSlice';
import { closeBackdrop, openBackdrop } from 'store/backdrop/backdropSlice';

interface IFindUserDialogProps {
  stateKey: string;
  onChange: (_name: string, _value: any) => void;
}

function FindUserDialog({ stateKey, onChange }: IFindUserDialogProps): JSX.Element {
  const { tmpStepper1 } = useProject();
  const dispatch = useAppDispatch();
  const handleCancel = () => {
    dispatch(closeDialog());
  };
  const handleClick = async () => {
    dispatch(openBackdrop({}));
    try {
      await onChange(stateKey, tmpStepper1.tmpProjectAdmins || []);
      await dispatch(
        changeStepper1Value({
          projectAdmins: tmpStepper1.tmpProjectAdmins,
          tmpProjectAdmins: [],
        }),
      );
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(closeBackdrop());
      handleCancel();
    }
  };
  return (
    <DialogContent width={{ desktop: 820, mobile: '100vw' }} height={{ desktop: 'fit-content', mobile: 'fit-content' }}>
      <DialogTitle hideCloseButton>담당자 목록</DialogTitle>
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'hidden !important' }}>
        <CustomCard sx={{ mt: '27px' }} content={false} border>
          <AccountsTable />
        </CustomCard>
      </DialogBody>
      <DialogButtons>
        <Stack direction="row" spacing={3.75}>
          <Button onClick={handleClick} variant="contained" sx={{ width: 100 }}>
            저장
          </Button>
          <ResetButton title="취소" onClick={handleCancel} sx={{ width: 100 }} />
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(FindUserDialog);
